import './ArticlesScreen.css';
import PageHero from '../../components/PageHero';
import ArticleCard from './components/ArticleCard';
import { useArticles } from './hooks/useArticles';
import { LoadingState, ErrorState } from '../../components';

function ArticlesScreen() {
  const {
    articles,
    loading,
    error,
    currentPage,
    paginationInfo,
    handleNextPage,
    handlePreviousPage,
    retry
  } = useArticles();

  const onNextPage = () => {
    handleNextPage();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const onPreviousPage = () => {
    handlePreviousPage();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="articles-screen">
      <PageHero 
        title="I Nostri Articoli"
        subtitle="Resta aggiornato sulle nostre iniziative e notizie"
      />

      <section className="articles-content">
        {loading && <LoadingState message="Caricamento articoli..." />}

        {error && <ErrorState message={error} onRetry={retry} />}

        {!loading && !error && articles.length === 0 && (
          <div className="empty-state">
            <p>Nessun articolo disponibile al momento.</p>
          </div>
        )}

        {!loading && !error && articles.length > 0 && (
          <>
            <div className="articles-grid">
              {articles.map(article => (
                <ArticleCard
                  key={article.id}
                  id={article.id}
                  title={article.title}
                  excerpt={article.text ? article.text.substring(0, 150) + '...' : ''}
                  date={article.date}
                  imageUrl={article.photo_link}
                />
              ))}
            </div>

            {paginationInfo && paginationInfo.totalPages > 1 && (
              <div className="pagination">
                <button 
                  onClick={onPreviousPage}
                  disabled={!paginationInfo.hasPreviousPage}
                  className="pagination-btn"
                >
                  Precedente
                </button>
                <span className="pagination-info">
                  Pagina {currentPage + 1} di {paginationInfo.totalPages}
                </span>
                <button 
                  onClick={onNextPage}
                  disabled={!paginationInfo.hasNextPage}
                  className="pagination-btn"
                >
                  Successiva
                </button>
              </div>
            )}
          </>
        )}
      </section>
    </div>
  );
}

export default ArticlesScreen;
